<template>
  <div class="header" @mouseleave="isShowChannel = false">
    <div class="main">
      <div class="head-left">
        <img @click="backHome" src="@/assets/newLogo-pc.svg" alt="大河号" />
      </div>
      <div class="search-box" v-if="currPath!='/search'">
        <span
          @click="showSearchType"
          :class="{ open: searchTypeFlag }">
          {{ searchTypeData[searchTypeId] }}
          <i class="el-icon-caret-bottom"></i>
        </span>
        <ul class="classtify" v-show="searchTypeFlag">
          <li v-for="(item,i) in searchTypeData"
            @click="searchTypeFlag=false;searchTypeId=i" :key="i">
            {{ item }}
          </li>
        </ul>
        <input type="text" placeholder="输入搜索的内容" v-model="keywords" @keyup.enter="toSearch" />
        <el-button type="text" class="el-icon-search" @click="toSearch"></el-button>
      </div>
      <div class="head-right">
        <div class="add-box" v-if="userToken&&isIndex">
          <el-button type="danger" size="small"
            class="to-add-btn"
            @click="showAddType"
            :class="{ 'open': addTypeFlag }"
            round
          >
            发布 <i class="el-icon-arrow-down"></i>
          </el-button>
          <ul class="classtify" v-show="addTypeFlag">
            <li @click="toAdd(1)">发文章</li>
            <li @click="toAdd(2)">发视频</li>
          </ul>
        </div>
        <span class="line" v-if="userToken&&isIndex"></span>
        <i class="el-icon-bell" @click="goInformationList"></i>
        <div>
          <template v-if="userToken">
            <img :src="userInfo.icon||'/static/img/mr-usericon.png'" class="avatar"
              @click="userMoreFlag = !userMoreFlag"
            />
            <ul class="user-classify" v-show="userMoreFlag">
              <li @click="goUserPersonal(userInfo.id)">个人主页</li>
              <li @click="goUserPersonalSetting">资料修改</li>
              <li @click="logOut">退出</li>
            </ul>
          </template>
          <span v-else @click="loginTo" class="loginBtn">登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["isIndex",'isUser'],
  data() {
    return {
      userToken: localStorage.getItem("UserToken"),
      userInfo: localStorage.getItem("UserInfo")&&JSON.parse(localStorage.getItem("UserInfo")),
      channelData: [],
      searchTypeId: 0,
      searchTypeFlag: false,
      searchTypeData: ["文章", "用户名"],
      keywords: '',
      userMoreFlag: false,
      currPath: this.$route.path,
      isShowChannel:false,
      addTypeFlag: false
    };
  },
  methods: {
    goUserPersonal(id){
        let routeData = this.$router.resolve('/user/personal/'+ id)
        window.open(routeData.href, '_blank')
    },
    goUserPersonalSetting(){
        let routeData = this.$router.resolve('/user/personalsetting')
        window.open(routeData.href, '_blank')
    },
    toSearch(){
      this.$router.push('/search?key='+ this.keywords +'&type='+ this.searchTypeId)
    },
    backHome() {
        this.$router.push("/");
    },
    loginTo() {
      this.$router.push("/login?url=" + window.location.pathname);
    },
    goInformationList() {
      if(this.userToken) {
        this.$router.push("/user/personalinformation");
      }else{
        this.$message.warning('请登录后查看');
      }
    },
    logOut() {
      this.$api.logOut({}).then((res) => {
        localStorage.removeItem('UserToken');
        localStorage.removeItem('UserInfo');
        if(this.$router.currentRoute.fullPath == '/'){
          this.$router.go(0)
        }else{
          this.$router.push("/");
        }
      });
    },
    getChannelData(){
      this.channelData = JSON.parse(localStorage.getItem("channelData"))||[];
      if(this.channelData.length==0){
        this.$api
        .channelList({
          type: 2,
        })
        .then((res) => {
          this.channelData = res.data.data;
          localStorage.setItem('channelData', JSON.stringify(res.data.data))
        });
      }
    },
    toAdd(i) {
      this.addTypeFlag = !this.addTypeFlag;
      const lcoalHref = window.location.href;
      i == 1
        ? lcoalHref.indexOf("/user/posts/add") > -1
          ? ""
          : this.$router.push("/user/posts/add")
        : i == 2
        ? lcoalHref.indexOf("/user/video/add") > -1
          ? ""
          : this.$router.push("/user/video/add")
        : lcoalHref.indexOf("/user/activety/add") > -1
        ? ""
        : this.$router.push("/user/activety/add");
    },
    showChannels(){
      this.isShowChannel = true;
      this.searchTypeFlag = false;
      this.addTypeFlag = false;
    },
    showSearchType(){
      this.searchTypeFlag = !this.searchTypeFlag;
      this.isShowChannel = false;
      this.addTypeFlag = false;
    },
    showAddType(){
      this.addTypeFlag = !this.addTypeFlag;
      this.isShowChannel = false;
      this.searchTypeFlag = false;
    }
  },
  created(){
    this.getChannelData();
  },
  mounted() {
    window.addEventListener('storage', (e) => {
      if(e.key=='UserToken'){
        this.userToken = e.newValue
      }else if(e.key=='UserInfo'){
        this.userInfo = e.newValue&&JSON.parse(e.newValue)
      }
    });
  }
};
</script>

<style scoped lang="scss">
.header {
  height: 60px;
  min-width: 1200px;
  background: linear-gradient(90deg, #317DFF 100%, #0B69F5 0%);
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 1000;
}
.main {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  height: 100%;
  font-size: 15px;
  .head-left {
    width: 400px;
    display: flex;
    align-items: center;
    img {
      width: auto;
      height: 35px;
      cursor: pointer;
    }
    span {
      margin-left: 50px;
      font-size: 16px;
      cursor: pointer;
      letter-spacing: 1px;
      position: relative;
      height: 60px;
      line-height: 60px;
      i {
        transition: all 0.3s;
        transform-origin: center;
      }
      &.on {
        i {
          transform: rotate(180deg);
        }
      }
      hr{
        display: none;
      }
      &:hover{
        hr{
          display: block;
          position: absolute;
          width: 48px;
          height: 4px;
          background: #FFFFFF;
          border: none;
          border-radius: 8px;
          bottom: -29px;
          top: 48px;
        }
      }
      &.index-link:hover{
        hr{
          left: -7px;
        }
      }
      &.channels:hover{
        hr{
          left: 9px;
        }
      }
    }
  }
  .classtify {
    left: 0;
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07);
    border-radius: 2px;
    color: #535353;
    padding: 10px 0;
    z-index: 2;
    top: 47px;
    &::before{
      border-top:6px solid transparent;
      border-bottom:6px solid #fff;
      border-left:6px solid transparent;
      border-right:6px solid transparent;
      content: " ";
      display: block;
      height: 0;
      margin-top: -22px;
      width: 0;
      position: absolute;
      left: 50%;
      margin-left: -6px;
    }
    li {
      // padding: 0 13px;
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      font-size: 15px;
      color: #535353;
      &.on,
      &:hover {
        background: #f5f5f5;
        color: #317DFF;
      }
    }
  }
  .search-box {
    position: relative;
    background: #f6f6f6;
    border-radius: 17px;
    border: 1px solid #ebebeb;
    width: 430px;
    height: 36px;
    line-height: 36px;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    span {
      color: #535353;
      cursor: pointer;
      font-size: 14px;
      i {
        transition: all 0.3s;
        transform-origin: center;
      }
      &.open {
        i {
          transform: rotate(180deg);
        }
      }
    }
    .classtify {
      width: 73px;
    }
    input {
      height: 100%;
      border: none;
      width: 76%;
      background: none;
      font-size: 14px;
      font-weight: 400;
      color: #A5A5A5;
    }
    button {
      color: #a5a5a5;
      font-size: 20px;
      padding: 0;
    }
  }
  .head-right {
    display: flex;
    align-items: center;
    position: relative;
    width: 300px;
    justify-content: flex-end;
    span {
      .el-icon-mobile-phone {
        font-size: 20px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .line{
      height: 18px;
      width: 1px;
      background: #fff;
      margin: 0 28px;
    }
    .loginBtn {
      margin-left: 30px;
      cursor: pointer;
    }
    .el-icon-bell {
      font-size: 22px;
      vertical-align: middle;
      cursor: pointer;
    }
    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      margin-left: 30px;
      cursor: pointer;
      margin-top: 2px;
    }
    .user-classify {
      position: absolute;
      right: -30px;
      top: 51px;
      background: #fff;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07);
      border-radius: 2px;
      color: #535353;
      padding: 10px 0;
      z-index: 222;
      &::before{
        border-top:6px solid transparent;
        border-bottom:6px solid #fff;
        border-left:6px solid transparent;
        border-right:6px solid transparent;
        content: " ";
        display: block;
        height: 0;
        margin-top: -22px;
        width: 0;
        position: absolute;
        left: 50%;
        margin-left: -6px;
      }
      li {
        padding: 0 18px;
        line-height: 2.5;
        cursor: pointer;
        font-size: 15px;
        color: #535353;
        &.on,
        &:hover {
          background: #f5f5f5;
          color: #317DFF;
        }
      }
    }
    .add-box {
      position: relative;
      .to-add-btn {
        height: 34px;
        font-size: 14px;
        width: 90px;
        border: none;
        background: #FB6743;
        i {
          transition: all 0.3s;
          transform-origin: center;
        }
        &.open {
          i {
            transform: rotate(180deg);
          }
        }
      }
      .classtify {
        width: 90px;
        // left: -10px;
      }
    }
  }
}
.channels-box{
  position: fixed;
  top: 60px;
  background: #fff;
  left: 0;
  right: 0;
  z-index: 111;
  box-shadow: 0px 4px 8px 2px rgba(134, 126, 126, 0.1);
  .channels-main{
    width: 1050px;
    margin: 0 auto;
    padding: 24px 0 8px;
    a{
      width: 115px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 18px;
      border: 1px solid #F2F2F2;
      line-height: 36px;
      color: #000000;
      font-size: 16px;
      display: inline-block;
      text-align: center;
      margin: 0 16px 18px;
      &:hover{
        background: #E5EFFE;
        border: 1px solid #317DFF;
        color: #317DFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue